<template>
    <span class="chart-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="16px" width="16px">
            <path
                :fill="fill"
                d="M16.67,5.4V0H7.33V8.33H0V24H24V5.4ZM7.33,22H2V10.33H7.33Zm7.34,0H9.33V2h5.34V22ZM22,22H16.67V7.4H22Z"
            />
        </svg>
    </span>
</template>

<script>
export default {
    name: 'IconChart',
    props: {
        fill: {
            type: String,
            default: '#fff',
        },
    },
};
</script>
